var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('BCXSearchSelect',{class:{'bc-general-setting-is-loading': _vm.isLoading},attrs:{"disabled":_vm.isLoading,"mode":"select","label":_vm.label,"name":"language","list":_vm.list},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }